import React from 'react';

const items = [
  'Color Masterbatch',
  'White Masterbatch',
  'UV Stabilizer',
  'NIR Absorber',
  'Antistatic Masterbatch',
  'Bio & rPET Solutions',
  'ISO 9001 Certified',
  'FDA 21 CFR Compliant',
  'REACH · RoHS · HALAL',
  '50+ Countries Served',
];

export default function TickerSection() {
  const track = [...items, ...items];
  return (
    <div className="ticker" aria-hidden="true">
      <div className="t-track">
        {track.map((label, i) => (
          <span className="t-item" key={`${label}-${i}`}>
            {label}
          </span>
        ))}
      </div>
    </div>
  );
}
